(function () {
  'use strict';

  var cfg = window.customwearProductViews;
  if (!cfg || typeof cfg.count !== 'number' || cfg.count < 1) {
    return;
  }

  var storageKey = cfg.storageKey || 'cw_pv_notice_dismiss';
  var delay = typeof cfg.delayMs === 'number' ? cfg.delayMs : 2600;

  try {
    if (window.sessionStorage.getItem(storageKey) === '1') {
      return;
    }
  } catch (e) {
    /* ignore */
  }

  function buildToast() {
    var wrap = document.createElement('div');
    wrap.className = 'cw-product-view-toast';
    wrap.setAttribute('role', 'status');
    wrap.setAttribute('aria-live', 'polite');

    var inner = document.createElement('div');
    inner.className = 'cw-product-view-toast__inner';

    var icon = document.createElement('span');
    icon.className = 'cw-product-view-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML =
      '<svg class="cw-product-view-toast__svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>';

    var text = document.createElement('p');
    text.className = 'cw-product-view-toast__text';
    text.textContent = (cfg.i18n && cfg.i18n.message) || '';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cw-product-view-toast__close';
    close.setAttribute('aria-label', (cfg.i18n && cfg.i18n.close) || 'Zamknij');
    close.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>';

    close.addEventListener('click', function () {
      wrap.remove();
      try {
        window.sessionStorage.setItem(storageKey, '1');
      } catch (err) {
        /* ignore */
      }
    });

    inner.appendChild(icon);
    inner.appendChild(text);
    inner.appendChild(close);
    wrap.appendChild(inner);
    document.body.appendChild(wrap);
  }

  window.setTimeout(buildToast, delay);
})();
